import { useMemo } from 'react'
import { Organization } from '@/types'
import apiService from '@/services/api'
import { useApiResource } from './useApiResource'

interface UseOrganizationsReturn {
  organizations: Organization[]
  loading: boolean
  error: string | null
  loadOrganizations: () => Promise<void>
  refreshOrganizations: () => Promise<void>
  stats: {
    total: number
    active: number
    inactive: number
    withPlans: number
    totalUsers: number
  }
}

export function useOrganizations(): UseOrganizationsReturn {
  const { data: organizations, loading, error, refresh } = useApiResource<Organization[]>(
    () => apiService.getAdminOrganizations(),
    [],
    { errorToastTitle: 'Error loading organizations' }
  )

  const stats = useMemo(() => {
    const total = organizations.length
    const active = organizations.filter((org) => org.active).length
    return {
      total,
      active,
      inactive: total - active,
      withPlans: organizations.filter((org) => org.plan).length,
      totalUsers: organizations.reduce((sum, org) => sum + (org.users?.length || 0), 0),
    }
  }, [organizations])

  return {
    organizations,
    loading,
    error,
    loadOrganizations: refresh,
    refreshOrganizations: refresh,
    stats,
  }
}
